export enum ProjectionTypes {
    Projection = 'Projection',
    PluriannualProjection = 'PluriannualProjection',
}
